import { setHiddenSpecificSkillCertificateApi } from "@/api/services/global/master";
import { TGetSpecificSkillCertificateListOutputDto } from "@/api/services/global/master/dtos/specificSkillCertificate/get-master-specific-skill-certificate-list.dto";
import { Modal } from "@/components/elements/Modal";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { showError } from "@/utils/error";
import { Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { FC } from "react";

type THiddenSpecificSkillCertificateModalProps = {
  hiddenSpecificSkillCertificate?: TGetSpecificSkillCertificateListOutputDto;
  setHiddenSpecificSkillCertificate: (value?: TGetSpecificSkillCertificateListOutputDto) => void;
};

export const HiddenSpecificSkillCertificateModal: FC<THiddenSpecificSkillCertificateModalProps> = ({
  hiddenSpecificSkillCertificate,
  setHiddenSpecificSkillCertificate,
}) => {
  const queryClient = useQueryClient();

  const handleConfirm = async () => {
    if (!hiddenSpecificSkillCertificate) return;

    try {
      await setHiddenSpecificSkillCertificateApi(hiddenSpecificSkillCertificate.id, {
        isHidden: !hiddenSpecificSkillCertificate.isHidden,
      });
      setHiddenSpecificSkillCertificate(undefined);
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GLOBAL.MASTER_SPECIFIC_SKILL_CERTIFICATE] });
    } catch (error) {
      showError(error);
    }
  };

  const handleCancel = () => {
    setHiddenSpecificSkillCertificate(undefined);
  };

  if (!hiddenSpecificSkillCertificate) return null;

  const actionText = hiddenSpecificSkillCertificate.isHidden ? "有効の確認" : "無効化の確認";
  const confirmText = hiddenSpecificSkillCertificate.isHidden ? "この特定技能証明書を有効化しますか？" : "この特定技能証明書を無効化しますか？";

  return (
    <Modal
      title={actionText}
      isOpen={!!hiddenSpecificSkillCertificate}
      onClose={handleCancel}
      enableCloseIcon={false}
      labelClose="キャンセル"
      labelOk="保存"
      onOk={() => handleConfirm()}
    >
      <Typography variant="body14" component="p" sx={{ paddingY: 2 }}>
        {confirmText}
      </Typography>
    </Modal>
  );
};
